import { Component } from "react";
import { Navigate } from "react-router-dom";
import getAuthenticationWorker from "./AuthenticationWorker";

class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
    };

    getAuthenticationWorker().onCallback((user) => {
      if (user) {
        this.setState({
          authenticated: true,
        });
      }
    });
  }

  render() {
    if (this.state.authenticated) {
      return <Navigate to={"/"} />;
    } else {
      return null;
    }
  }
}

export default Signin;
